export const getEmptyRows = (rows, page, rowsPerPage) => {
    return rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
};
